export const PLAYER_JS_CONTEXT = 'player.js'
export const PLAYER_JS_VERSION = '0.0.11'

export const PLAYER_JS_METHODS = {
    PLAY: 'play',
    PAUSE: 'pause',
    MUTE: 'mute',
    UNMUTE: 'unmute',
    SET_CURRENT_TIME: 'setCurrentTime',
    SET_VOLUME: 'setVolume',
    SET_LOOP: 'setLoop',
    GET_PAUSED: 'getPaused',
    GET_CURRENT_TIME: 'getCurrentTime',
    GET_DURATION: 'getDuration',
    GET_MUTED: 'getMuted',
    GET_VOLUME: 'getVolume',
    GET_LOOP: 'getLoop',
    ADD_EVENT_LISTENER: 'addEventListener',
    REMOVE_EVENT_LISTENER: 'removeEventListener',
} as const

export const PLAYER_JS_EVENTS = {
    READY: 'ready',
    PLAY: 'play',
    PAUSE: 'pause',
    ENDED: 'ended',
    TIME_UPDATE: 'timeupdate',
    SEEKED: 'seeked',
    PROGRESS: 'progress',
    ERROR: 'error',
} as const

export const SUPPORTED_METHODS: ReadonlyArray<string> = Object.values(PLAYER_JS_METHODS)

export const SUPPORTED_EVENTS: ReadonlyArray<string> = Object.values(PLAYER_JS_EVENTS)
